module.exports = __webpack_public_path__ + "media/img/event/ace-logo-7d9209bf38fc2c1744f09d988c64bbd3.png";